import React, { useState, useCallback } from 'react';

import { HeaderProfile } from './header-profile';

import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { FormattedMessage } from 'react-intl';

import colors from '../../constants/colors';
import { SidePanelNav } from '../side-panel/side-panel-nav';
import { LanguageSwitcher } from './language-switcher';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    backgroundColor: theme.palette.primary.main,
    height: '100%',
  },
  icon: {
    color: '#ffffff',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: '1rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '1rem',
    },
  },
  divider: {
    height: '2rem',
    width: 2,
    backgroundColor: colors.lightgray,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 2,
    },
  },
  logOutButton: {
    color: '#ffffff',
    '&.Mui-disabled': {
      color: colors.lightgray,
    },
  },
}));

export function HeaderMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLogoutPending, setIslogoutPending] = useState(false);

  const handleOpenMenu = () => setIsOpen(true);
  const handleCloseMenu = () => setIsOpen(false);

  const handleLogout = useCallback(async () => {
    try {
      setIslogoutPending(true);
      // await logout();
      window.location.href = '/Shibboleth.sso/Logout?return=/logout';
    } catch (err) {
      console.error('Logout unsuccessful:', err);
    } finally {
      setIslogoutPending(false);
    }
  }, []);

  const component = (
    <div className={classes.container}>
      <HeaderProfile />
      <div className={classes.divider} />
      {smallScreen && <SidePanelNav />}
      <Button
        startIcon={<ExitToAppIcon className={classes.icon} />}
        className={classes.logOutButton}
        onClick={handleLogout}
        disabled={isLogoutPending}
        endIcon={isLogoutPending ? <CircularProgress size={20} /> : null}
      >
        <FormattedMessage id="VPUK__LOGOUT__BUTTON" />
      </Button>
      <LanguageSwitcher />
    </div>
  );

  return smallScreen ? (
    <>
      <Drawer anchor="right" open={isOpen} onClose={handleCloseMenu}>
        <div className={classes.drawerContainer}>
          <div>
            <IconButton onClick={handleCloseMenu}>
              <ChevronRightIcon className={classes.icon} />
            </IconButton>
          </div>
          {component}
        </div>
      </Drawer>
      <IconButton onClick={handleOpenMenu} className={classes.icon}>
        <MenuIcon />
      </IconButton>
    </>
  ) : (
    component
  );
}
